const website = document.querySelector('.website__content');
const header = document.querySelector('.header__mobile');
const footer = document.querySelector('.website__footer');
const hamburger = document.querySelector('.header__hamburger');
const exit = document.querySelector('.header__exit');
const menuBox = document.querySelector('.header__box');
const menu = document.querySelector('.header-menu__list');

if (hamburger && menuBox) {
	document.body.addEventListener('click', function(event) {
		if (event.target === hamburger || hamburger.contains(event.target)) {
			//Click on hamburger menu
			menuBox.classList.toggle('active');
			menu.classList.toggle('active');
		} else if (event.target === exit || exit.contains(event.target)) {
			//Click on menu exit
			menuBox.classList.remove('active');
			menu.classList.remove('active');
		} else if (menu.classList.contains('active') && menu.contains(event.target)) {
			// Click on a link inside the menu, close the menu
			if (event.target.tagName === 'a') {
				menuBox.classList.remove('active');
				menu.classList.remove('active');
			}
		} else if (website.contains(event.target)) {
			// Click outside the menu, close it
				menuBox.classList.remove('active');
				menu.classList.remove('active');
		} else if (header.contains(event.target)) {
			// Click outside the menu, close it
				menuBox.classList.remove('active');
				menu.classList.remove('active');
		} else if (footer.contains(event.target)) {
			// Click outside the menu, close it
				menuBox.classList.remove('active');
				menu.classList.remove('active');
		}
	});
} 

/* const menuContainer = document.querySelector('.header__menu');
const menu = document.querySelector('.header-menu');
const header = document.querySelector('.header');
const headerRow = document.querySelector('.header__row');
const hamburger = document.querySelector('#hamburger');


if (hamburger && menu) {
	document.body.addEventListener('click', function(event) {
		if (event.target === hamburger || hamburger.contains(event.target)) {
			headerRow.classList.toggle('header__row--has-active-menu');
			header.classList.toggle('header--has-active-menu');
			hamburger.classList.toggle('active');
		} else if (menu.classList.contains('active') && menu.contains(event.target)) {
			// Click on a link inside the menu, close the menu
			if (event.target.tagName === 'A') {
				website.classList.remove('website--has-active-menu');
				menuContainer.classList.remove('active');
				menu.classList.remove('active');
				headerRow.classList.remove('header__row--has-active-menu');
				header.classList.remove('header--has-active-menu');
				hamburger.classList.remove('active');
			}
		} else {
			// Click outside the menu, close it
			website.classList.remove('website--has-active-menu');
			menuContainer.classList.remove('active');
			menu.classList.remove('active');
			headerRow.classList.remove('header__row--has-active-menu');
			header.classList.remove('header--has-active-menu');
			hamburger.classList.remove('active');
	}
	});
} */